import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import PropTypes from 'prop-types';
import FilterOpened from './FilterOpened';
import FilterClosed from './presentionalComponents/FilterClosed';
import {
  filterTypes, preloadImage, touchDeviceType, getPriceRangeLabel,
  isPriceRangeValid
} from './filterHelpers';
import { betweenPropShape, filterOptionPropTypes } from './propTypes';
import { toggleXhrErrorWarning } from '../../../../../appState/ducks/listingPageSetup';

class Filter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      opened: this.props.openedFilter || false
    };

    this.preloadImages();
    this.toggleOptionsListVisibility = this.toggleOptionsListVisibility.bind(this);
  }

  getSelectedOptions() {
    if (this.props.type === filterTypes.price && isPriceRangeValid(
      {
        type: this.props.type,
        between: this.props.selectedBetween
      }
    )) {
      return getPriceRangeLabel(this.props.selectedBetween);
    }

    return this.props.options
      .filter(option => option.active)
      .map((activeOption) => {
        if (this.props.type === filterTypes.rating) {
          if (parseInt(activeOption.value, 10) === this.props.maxValue) {
            return `${activeOption.value / 2} stars`;
          }
          return `${activeOption.value / 2} stars or more`;
        }

        return activeOption.label;
      })
      .join(', ');
  }

  /**
   * If filter options contains some images, we should preload them to avoid random appearing
   * after expanding filter options list. Thus this preloading can not be in CheckboxList component.
   */
  preloadImages() {
    this.props.options.forEach((filterOption) => {
      if (filterOption.images && filterOption.images.length > 0) {
        preloadImage(filterOption.images[0].url);
      }
    });
  }

  toggleOptionsListVisibility() {
    if (touchDeviceType(this.props.deviceType)) {
      if (this.state.opened) {
        this.props.setSelectedFilter(null);
      } else {
        this.props.setSelectedFilter(this.props.name);
        this.props.toggleXhrErrorWarning(false);
      }
    }

    this.setState(
      state => ({ opened: !state.opened })
    );
  }

  render() {
    return (
      this.state.opened
        ? <FilterOpened
          toggleOptionsListVisibility={this.toggleOptionsListVisibility}
          {...this.props}
        />
        : <FilterClosed
          toggleOptionsListVisibility={this.toggleOptionsListVisibility}
          selectedOptions={this.getSelectedOptions()}
          {...this.props}
        />
    );
  }
}

Filter.displayName = 'Filter';

Filter.propTypes = {
  openedFilter: PropTypes.bool,
  setSelectedFilter: PropTypes.func,
  deviceType: PropTypes.oneOf(['wide', 'desktop', 'tablet', 'mobile']).isRequired,
  toggleXhrErrorWarning: PropTypes.func,
  name: PropTypes.string.isRequired,
  maxValue: PropTypes.number,
  type: PropTypes.oneOf(Object.values(filterTypes)).isRequired,
  options: PropTypes.arrayOf(filterOptionPropTypes).isRequired,
  selectedBetween: PropTypes.shape({
    left: betweenPropShape.isRequired,
    right: betweenPropShape.isRequired
  })
};

Filter.defaultProps = {
  openedFilter: false,
  toggleXhrErrorWarning: () => {},
  setSelectedFilter: () => {},
  maxValue: 0,
  selectedBetween: null
};

export default connect(null, { toggleXhrErrorWarning })(Filter);
